import { NAV_ITEMS, type NavId } from "../lib/routes";

interface BottomNavProps {
  active: NavId;
  onNavigate: (path: string) => void;
}

export function BottomNav({ active, onNavigate }: BottomNavProps) {
  return (
    <nav className="bottom-nav" aria-label="ناوبری پایین">
      {NAV_ITEMS.map((item) => {
        const isActive = item.id === active;
        return (
          <button
            key={item.id}
            type="button"
            className="bottom-nav__item"
            aria-current={isActive ? "page" : undefined}
            data-active={isActive || undefined}
            onClick={() => onNavigate(item.path)}
          >
            <span className="bottom-nav__dot" aria-hidden="true" />
            <span>{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
